module.exports = __webpack_public_path__ + "638cfc3c608eced8c624a1c1f9833242.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/modals/destructive-operation/destructive-operation.html
// module id = 1077
// module chunks = 0